module.exports = __webpack_public_path__ + "static/media/arrow-new.73803295.svg";